import { Box, Paper, Typography } from "@mui/material";
import { BuildOutlined } from "@mui/icons-material";
import { PageHeader } from "./PageHeader";

export interface PantallaPendienteProps {
  eyebrow: string;
  title: string;
  subtitle: string;
}

/**
 * Marcador de posición estándar para pantallas del flujo de formalización que aún no tienen
 * implementación dedicada. Muestra un aviso de "en construcción" con el header de la pantalla.
 */
export const PantallaPendiente = ({ eyebrow, title, subtitle }: PantallaPendienteProps) => (
  <Box>
    <PageHeader eyebrow={eyebrow} title={title} subtitle={subtitle} />

    <Paper variant="lendia_paper" sx={{ textAlign: "center", p: "56px 24px" }}>
      <Box
        sx={{
          width: 72,
          height: 72,
          borderRadius: "18px",
          bgcolor: "tokens.warningBg",
          border: "1px solid",
          borderColor: "tokens.warningBorder",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          mx: "auto",
          mb: "18px",
        }}
      >
        <BuildOutlined sx={{ fontSize: 32, color: "warning.main" }} />
      </Box>
      <Typography sx={{ fontSize: 17, fontWeight: 600, color: "primary.dark", mb: "8px" }}>
        Pantalla en construcción
      </Typography>
      <Typography sx={{ fontSize: 13.5, color: "tokens.textTertiary", maxWidth: 380, mx: "auto", lineHeight: 1.6 }}>
        Esta sección está siendo desarrollada. Te notificaremos por correo y WhatsApp en cuanto esté lista para
        continuar.
      </Typography>
    </Paper>
  </Box>
);
